// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__HPr2V","infos":"styles_infos__yJ9BK","icons":"styles_icons__2WOtt"};